import { Link } from "react-router-dom";

export function Footer() {
    return (
        <footer className="w-full border-t border-slate-100 py-8 mt-4">
            <div className="container mx-auto px-4">
                <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                    <div className="text-sm text-slate-500">
                        © {new Date().getFullYear()} Quizzler. All rights reserved.
                    </div>
                    <div className="flex gap-6">
                        <Link to="/about" className="text-sm text-slate-500 hover:text-slate-900 transition-colors">
                            About
                        </Link>
                        <Link to="/privacy" className="text-sm text-slate-500 hover:text-slate-900 transition-colors">
                            Privacy Policy
                        </Link>
                        <Link to="/terms" className="text-sm text-slate-500 hover:text-slate-900 transition-colors">
                            Terms
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
